export const modais = [
  {
    "input": `Últimas mensagens:
      - Did you go to the party? [naturality_help]

      Avaliar:
      - Yeah, I went. [?]`,
    "expected_class": "naturality_help"
  },
  {
    "input": `Últimas mensagens:
      - I had to do this. [positive]

      Avaliar:
      - No, you hadn't. [?]`,
    "expected_class": "grammar_error"
  },
  {
    "input": `Últimas mensagens:
      - Did you see the that? [too_simple]

      Avaliar:
      - Yeah, I saw. [?]`,
    "expected_class": "grammar_error"
  },
  {
    "input": `Últimas mensagens:
      - Do you have many books? [positive]

      Avaliar:
      - Yeah, I have. [?]`,
    "expected_class": "grammar_error"
  },
  {
    "input": `Últimas mensagens:
      - Okay. So, I'll talk about automation, I think. Yeah. [too_simple]
      - Okay. When did you implement it? [naturality_help]

      Avaliar:
      - Just two days ago. [?]`,
    "expected_class": "positive"
  },
  {
    "input": `Últimas mensagens:
      - Where were you? [too_simple]
      - I had to do something. [positive]

      Avaliar:
      - Yes, you had. [?]`,
    "expected_class": "grammar_error"
  },
  {
    "input": `Últimas mensagens:
      - I go to the store yesterday. [grammar_error]

      Avaliar:
      - What did you buy? [?]`,
    "expected_class": "grammar_error",
  },
  {
    "input": `Últimas mensagens:
    - Would you join? [positive]

    Avaliar:
    - I can't. I'm already very busy, full of things, sorry. [?]`,
    "expected_class": "grammar_error",
  },
  {
    "input": `Últimas mensagens:
    - Have you eaten? [too_simple]

    Avaliar: - No, I'm actually very hungry. [?]`,
    "expected_class": "grammar_error",
  },
];

// {
  //   "input": `Últimas mensagens:
  //     - So, can he play anything?

  //   Avaliar:
  //     - He can plays guitar well.`,
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Did you go to the party?\n\nAvaliar:\n- Yes, I went.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Do you like coffee?\n\nAvaliar:\n- Yes, I like.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Can you swim?\n\nAvaliar:\n- Yes, I can swim.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Do you have a pen?\n\nAvaliar:\n- Yes, I have.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Are you reading?\n\nAvaliar:\n- Yes, I reading.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Did you see that movie?\n\nAvaliar:\n- Yes, I saw.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Does she play tennis?\n\nAvaliar:\n- Yes, she plays.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Can she cook?\n\nAvaliar:\n- Yes, she can cook.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Do you have time to talk?\n\nAvaliar:\n- Yes, I have time.",
  //   "expected_class": "grammar_error",
  // },
  // {
  //   "input": "Últimas mensagens:\n- Is she studying?\n\nAvaliar:\n- Yes, she studying.",
  //   "expected_class": "grammar_error",
  // }

export const data = []
